import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const tasksTexts: Record<string, IOnboardingStepText> = {
  'tasks.intro': {
    title: 'Задачи',
    text: 'Все ваши задачи из любых разделов портала: заявок, аудитов, предложений и других. Покажем, как с ними работать.',
  },
  'tasks.create': {
    title: 'Новая задача',
    text: 'Поручите работу сотруднику: срок, описание, чек-лист и обязательный отчёт.',
  },
  'tasks.search': {
    title: 'Поиск',
    text: 'Введите слово или номер и нажмите Enter.',
  },
  'tasks.role': {
    title: 'Роль',
    text: 'Покажет задачи, где вы исполнитель, постановщик или наблюдатель.',
  },
  'tasks.source': {
    title: 'Основание',
    text: 'Из какого раздела пришла задача: заявка, аудит, предложение и т.д.',
  },
  'tasks.quickFilters': {
    title: 'Быстрые фильтры',
    text: 'Просроченные, срочные и задачи, где ждут именно вас.',
  },
  'tasks.resetFilters': {
    title: 'Сброс фильтров',
    text: 'Возвращает список к виду по умолчанию.',
  },
  'tasks.hideCompleted': {
    title: 'Завершённые',
    text: 'Скрывает выполненные задачи, чтобы не мешали.',
  },
  'tasks.filters': {
    title: 'Фильтры колонок',
    text: 'Значок в заголовке колонки открывает фильтр по ней.',
  },
  'tasks.demoRowMenu': {
    title: 'Меню строки',
    text: 'Срочность, закрепление наверху списка, ссылка и завершение — прямо из таблицы.',
  },
  'tasks.demoRow': {
    title: 'Карточка задачи',
    text: 'Клик открывает задачу. Задача заявки или аудита откроется в карточке этой записи. Откроем учебную.',
  },
  'tasks.card.chat': {
    title: 'Чат задачи',
    text: 'Обсуждение с постановщиком и исполнителями прямо в карточке.',
  },
  'ear.link': {
    title: 'Ссылка',
    text: 'Скопируйте ссылку на задачу, чтобы отправить коллеге.',
  },
}
